<dbw-investor-viewer-accordion
  anchorId="investor-viewer-referentiels-externes"
  accordionTitle="Référentiels externes">
  <div
    accordion-description
    class="tag-cluster">
    <oui-tag
      type="status"
      size="big"
      [status]="getBoxPlacementTagStatus()">
      {{ getBoxPlacementTagLabel() }}
    </oui-tag>
    <oui-tag
      type="status"
      size="big"
      [status]="getImmoTagStatus()">
      {{ getImmoTagLabel() }}
    </oui-tag>
    <oui-tag
      type="status"
      size="big"
      [status]="getArianeTagStatus()">
      {{ getArianeTagLabel() }}
    </oui-tag>
  </div>

  <div class="external-accordion-stack">
    <dbw-investor-viewer-accordion
      accordionTitle="Box Placement"
      level="subtitle"
      [loading]="boxPlacementLoading()">
      <span accordion-description>{{ getBoxPlacementSummary() }}</span>

      @if (boxPlacementLoading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Chargement des informations Box Placement en cours.</p>
        </dbw-state-card>
      } @else if (boxPlacementError()) {
        <dbw-state-card
          appearance="error"
          [compact]="true">
          <p>{{ boxPlacementError() }}</p>
        </dbw-state-card>
      } @else {
        @if (boxPlacement(); as result) {
          <div class="note-banner dbw-card dbw-card--md">
            <strong>{{ result.message }}</strong>
          </div>

          <div class="reference-grid">
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Investisseur</span>
              <strong>#{{ result.investorId }}</strong>
            </article>
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Opérations Box</span>
              <strong>{{ formatBoolean(result.hasOperations) }}</strong>
            </article>
          </div>
        } @else {
          <dbw-state-card
            appearance="info"
            [compact]="true">
            <p>Les informations Box Placement ne sont pas encore disponibles.</p>
          </dbw-state-card>
        }
      }
    </dbw-investor-viewer-accordion>

    <dbw-investor-viewer-accordion
      accordionTitle="ImmoFactory"
      level="subtitle"
      [loading]="immoLoading()">
      <span accordion-description>{{ getImmoSummary() }}</span>

      @if (immoLoading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Chargement des informations ImmoFactory en cours.</p>
        </dbw-state-card>
      } @else if (immoError()) {
        <dbw-state-card
          appearance="error"
          [compact]="true">
          <p>{{ immoError() }}</p>
        </dbw-state-card>
      } @else {
        @if (immoOptionIntention(); as result) {
          <div class="note-banner dbw-card dbw-card--md">
            <strong>{{ result.message }}</strong>
          </div>

          <div class="reference-grid">
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Code investisseur</span>
              <strong>{{ formatText(result.investorCode) }}</strong>
            </article>
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Intention d'option</span>
              <strong>{{ formatBoolean(result.hasOptionIntention) }}</strong>
            </article>
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Correspondance ImmoFactory</span>
              <strong>{{ formatIdentity(result.matchedLastName, result.matchedFirstName, 'Aucune correspondance') }}</strong>
            </article>
          </div>
        } @else {
          <dbw-state-card
            appearance="info"
            [compact]="true">
            <p>Les informations ImmoFactory ne sont pas encore disponibles.</p>
          </dbw-state-card>
        }
      }
    </dbw-investor-viewer-accordion>

    <dbw-investor-viewer-accordion
      accordionTitle="Ariane (dump Minotaure)"
      level="subtitle"
      [loading]="arianeDumpState().loading">
      <span accordion-description>{{ getArianeSummary() }}</span>

      @if (arianeDumpState().loading) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Chargement du dump Ariane en cours.</p>
        </dbw-state-card>
      } @else if (arianeDumpState().error) {
        <dbw-state-card
          appearance="error"
          [compact]="true">
          <p>{{ arianeDumpState().error }}</p>
        </dbw-state-card>
      } @else {
        @if (arianeDumpState().result; as result) {
          <div class="note-banner dbw-card dbw-card--md">
            <strong>{{ result.message }}</strong>
          </div>

          <div class="reference-grid">
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">ArianeId Atlas</span>
              <strong>{{ formatText(result.atlasArianeId) }}</strong>
            </article>
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">ArianeId dump</span>
              <strong>{{ formatText(result.arianeId) }}</strong>
            </article>
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Import Minotaure</span>
              <strong>{{ formatText(result.jobId) }}</strong>
            </article>
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Importé le</span>
              <strong>{{ (result.importTimestamp | date: 'dd/MM/yyyy HH:mm') ?? '-' }}</strong>
            </article>
            <article class="identity-item dbw-card dbw-card--lg">
              <span class="identity-item__label">Statut</span>
              <strong>{{ formatText(result.status) }}</strong>
            </article>
          </div>

          @if (result.errorMessage) {
            <dbw-state-card
              appearance="error"
              [compact]="true">
              <p>{{ result.errorMessage }}</p>
            </dbw-state-card>
          }

          @if (result.dumpJson) {
            <pre class="ariane-dump__json">{{ formatArianeDumpJson(result.dumpJson) }}</pre>
          }

          <div class="ariane-dump__actions">
            <oui-button
              type="text"
              color="secondary"
              (click)="loadArianeDump()"
              >Recharger le dump</oui-button
            >
          </div>
        } @else {
          <dbw-state-card
            appearance="info"
            [compact]="true">
            <p>
              Le dump Ariane n'est pas chargé automatiquement car il peut être volumineux.
            </p>
          </dbw-state-card>

          <div class="ariane-dump__actions">
            <oui-button
              color="primary"
              (click)="loadArianeDump()"
              >Charger le dump</oui-button
            >
          </div>
        }
      }
    </dbw-investor-viewer-accordion>
  </div>
</dbw-investor-viewer-accordion>
